import { useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import './Home.css';
import { Box, Button, Center, Collapse, Divider, Flex, Grid, Image, Skeleton, SkeletonText, Spacer, Table, TableCaption, TableContainer, Tbody, Td, Text, Tfoot, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react';
import { Layout } from './Layout';
import { NewDossier } from './Dossiers/NewDossier';
import { IArticle, IDossier } from './types';
import { getArticles } from './API/news';
import { Link as ReactLink} from 'react-router-dom';
import { getDossiers } from './API/dossier';
import BigDossierCard from './Dossiers/BigDossierCard';
import DossierCard from './Dossiers/DossierCard';
import { faBullhorn, faCheckToSlot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getCurrentElection, getFinishedElection } from './API/elections';
import { ArticleCardSkeleton } from './News/ArticleCardSkeleton';
import ArticleCard from './News/ArticleCard';
import { Feed } from './Feed';
import { getTutoStatus } from './API/users';

export const SLIDER_IMAGES = ['/rectorat/pic1.JPG', '/rectorat/pic2.JPG', '/rectorat/pic3.JPG', '/rectorat/pic4.JPG', '/rectorat/pic5.JPG', '/rectorat/pic6.JPG', '/rectorat/pic7.JPG' ];

function Home() {
  const new_folder_disclosure = useDisclosure();

  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: 'start', dragFree: true }, [
    Autoplay({ delay: 3500, stopOnInteraction: false }),
  ]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => setSelectedIndex(emblaApi.selectedScrollSnap());
    emblaApi.on('select', onSelect);
    return () => { emblaApi.off('select', onSelect); };
  }, [emblaApi]);

  // Articles
  const [articles, setArticles] = useState<IArticle[]>([]);
  const [articlesFetched, setArticlesFetched] = useState<boolean>(false);
  useEffect(() => {
    getArticles(3, 0, "createdAt", true).then((resp) => {
      setArticles(resp.data.articles);
      setArticlesFetched(true);
    });
  }, []);

  // Dossiers
  const [highPriorityDossiers, setHighPriorityDossiers] = useState<IDossier[]>([]);
  const [highPriorityDossiersFetched, setHighPriorityDossiersFetched] = useState<boolean>(false);
  const [openDossiers, setOpenDossiers] = useState<IDossier[]>([]);
  const [openDossiersFetched, setOpenDossiersFetched] = useState<boolean>(false);
  useEffect(() => {
    // High priority dossiers
    getDossiers(1000, 0, "deadline", [], true, true, true).then((resp) => {
      setHighPriorityDossiers(resp.data.dossiers);
      setHighPriorityDossiersFetched(true);
    });
    // Open dossiers, not high priority
    getDossiers(1000, 0, "deadline", [], false, true, true).then((resp) => {
      setOpenDossiers(resp.data.dossiers);
      setOpenDossiersFetched(true);
    });
  }, []);

  // Dossier banner size
  const [dossierBannerHeight, setDossierBannerHeight] = useState<number>(0);
  
  useEffect(() => {
    const element = document.getElementById('dossiers_banner');
    if (element) {
      setDossierBannerHeight(element.clientHeight);
    }
  }, [highPriorityDossiersFetched, openDossiersFetched]);

  // Elections
  const elections_disclosure = useDisclosure();
  const finished_election_disclosure = useDisclosure();
  useEffect(() => {
    getCurrentElection().then((resp) => {
      if (resp.data.election.open)
        elections_disclosure.onOpen();
    }).catch((error) => {});

    getFinishedElection().then((resp) => {
      if (resp.data.election)
        finished_election_disclosure.onOpen();
    }).catch((error) => {});

    getTutoStatus().then((resp) => {
      if (!resp.data.seen) {
        window.location.href = '/welcome';
      }
    }).catch((error) => {});
  }, []);

// Ressources financières
// Enseignement
// Juridique

  return (<>
    <Layout>

    <Collapse in={finished_election_disclosure.isOpen} animateOpacity>
      <Center mt={10} pb={8}>
        <Box boxShadow={"rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px"} border={"1pt solid #e2e2dd"} bgColor={"white"} p={10} w={'80%'}>
          <Text fontWeight={'900'} color={"#4a4a4a"} letterSpacing={'-.05rem'} fontSize={"24px"}><FontAwesomeIcon icon={faBullhorn} style={{marginRight:"5px"}} /> Élections du Bureau ADERE</Text>
          <Text color={"#131313"}  mt={5}>
            Les résultats de l'élection du nouveau Bureau de l'ADERE sont disponibles.
          </Text>

          <Center mt={5}>
            <ReactLink to={'/elections/end'}>
              <Button p={7} colorScheme="purple" onClick={new_folder_disclosure.onOpen} leftIcon={<FontAwesomeIcon icon={faCheckToSlot} style={{marginRight:"5px"}} />}>Consulter les résultats</Button>
            </ReactLink>
          </Center>
        </Box>
      </Center>
    </Collapse>

    <Collapse in={elections_disclosure.isOpen} animateOpacity>
      <Center mt={10} pb={8}>
        <Box boxShadow={"rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px"} border={"1pt solid #e2e2dd"} bgColor={"white"} p={10} w={'80%'}>
          <Text fontWeight={'900'} color={"#4a4a4a"} letterSpacing={'-.05rem'} fontSize={"24px"}><FontAwesomeIcon icon={faBullhorn} style={{marginRight:"5px"}} /> Élections du Bureau ADERE</Text>
          <Text color={"#131313"}  mt={5}>
            Les élections du Bureau de l'ADERE sont ouvertes.
          </Text>

          <Center mt={5}>
            <ReactLink to={'/elections'}>
              <Button p={7} colorScheme="purple" onClick={new_folder_disclosure.onOpen} leftIcon={<FontAwesomeIcon icon={faCheckToSlot} style={{marginRight:"5px"}} />}>Consulter les candidatures</Button>
            </ReactLink>
          </Center>
        </Box>
      </Center>
    </Collapse>
    
    {/* <Box bgColor={"white"} border={"1pt solid #e2e2dd"} width={"100%"} position={"absolute"} left={0} zIndex={-1} height={dossierBannerHeight+"px"} p={2}></Box> */}


    <Text 
      mt={"60px"}
      mb={3} 
      ms={3} 
      color={"#b44e50"} 
      fontWeight={'800'} 
      fontSize={'lg'}
      cursor={'default'}
      >
        ÉLECTIONS 2026 : Séance d'échange entre l'ADERE et les candidats à l'élection rectorale</Text>
      <Box mb={5} height={'4px'} bgColor={"#940104"} width={'100%'} />

      <Box boxShadow={"rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px"} p={6} bgColor={"white"} width={'100%'} border={'0.5px solid #E2E8F0'}>
        <Text mb={3}>
          Le 14 avril 2026, le Bureau de l'ADERE a organisé une séance d'échange avec Anne-Sophie Nyssen et Damien Ernst, candidat·es à l'élection rectorale de l'Université de Liège.
        </Text>

        <Text>
          Cet événement a offert à nos membres l'opportunité d'interroger directement les candidats sur leurs programmes respectifs, et plus particulièrement sur la place qu'ils entendent accorder aux directeurs et directrices d'équipe de recherche et d'enseignement dans la gouvernance universitaire au cours de leur prochain mandat.
        </Text>

        {/* Photo slider */}
        <Box mt={5} overflow="hidden" borderRadius="md" ref={emblaRef} cursor="grab">
          <Flex>
            {SLIDER_IMAGES.map((src, i) => (
              <Box
                key={i}
                flex="0 0 auto"
                width={['85%', '55%', '38%']}
                me={3}
                borderRadius="md"
                overflow="hidden"
                boxShadow="rgba(0,0,0,0.12) 0px 4px 16px"
              >
                <img
                  src={src}
                  alt={`Photo ${i + 1}`}
                  style={{ width: '100%', height: '240px', objectFit: 'cover', display: 'block' }}
                  draggable={false}
                />
              </Box>
            ))}
          </Flex>
        </Box>

        {/* Link to recordings */}
        <Center mt={2}>
        <ReactLink to={'/rectorat'} onClick={() => window.scrollTo(0, 0)}>
        <Button
              width={'fit-content'} p={6} m={3} color={"white"} _hover={{backgroundColor:"#006977"}} bgColor={"#004851"} size="md" mt={5} fontSize={'10pt'} fontWeight={'700'} letterSpacing={'.8px'}>
                Accéder à la rediffusion
        </Button>
        </ReactLink>
        </Center>

        {/* Dot indicators */}
        <Flex justify="center" gap={2} mt={3}>
          {SLIDER_IMAGES.map((_, i) => (
            <Box
              key={i}
              w={selectedIndex === i ? '20px' : '8px'}
              h="8px"
              borderRadius="full"
              bgColor={selectedIndex === i ? '#940104' : '#d0d0cc'}
              transition="all 0.3s ease"
              cursor="pointer"
              onClick={() => emblaApi?.scrollTo(i)}
            />
          ))}
        </Flex>
      </Box>

    <Box mt={10} mb={5} height={'1px'} bgColor={"#E2E8F0"} width={'100%'} />

    <Box id='dossiers_banner' mt={0}>
      <Text fontWeight={'900'} color={"#b3b3af"} fontSize={['4xl', '4xl', '5xl']} letterSpacing={"-.1rem"}> Dossiers en cours</Text>

      <Text mb={10} ps={4}>
        Les dossiers présents sur cette page sont actuellement ouverts et nécessitent l'attention des membres de l'ADERE.
      </Text>

      {highPriorityDossiersFetched && highPriorityDossiers.length == 0 && openDossiers.length == 0 && <Center mt={10}>
        <Text color={"gray.500"}>Aucun dossier pour le moment.</Text>
      </Center>
      }

      {!highPriorityDossiersFetched || highPriorityDossiers.length > 0 && (<>
        <Text mb={3} ms={3} color={"#b44e50"} fontWeight={'800'} fontSize={'sm'}>DOSSIERS PRIORITAIRES OUVERTS</Text>
        <Box mb={10} height={'4px'} bgColor={"#940104"} width={'100%'} />
      </>)}
      
      {highPriorityDossiers.map((dossier, index) => {
        return (
          <Box key={index} mb={(index < 2) ? 2 : 0}>
            <BigDossierCard dossier={dossier} />
          </Box>
      )})}

      {!highPriorityDossiersFetched &&
        <Skeleton boxShadow={"rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px"} height={'250px'} width={"100%"} mb={"50px"}  />
      }
      
      {!openDossiersFetched || openDossiers.length > 0 && (
        <Box mb={5} mt={10}>
          <Text mb={3} ms={3} color={"#00707f"} fontWeight={'800'} fontSize={'sm'}>DOSSIERS OUVERTS</Text>
          <Box mb={10} height={'4px'} bgColor={"#00707f"} width={'100%'} />
        </Box>
      )}

      {!openDossiersFetched &&
        <Grid templateColumns={['repeat(1, 1fr)', 'repeat(1, 1fr)', 'repeat(3, 1fr)']} gap={6} mt={3} mb={6}>
          {[1, 2, 3, 4, 5].map((_, index) => {
            return (
              <Skeleton key={index} boxShadow={"rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px"} height={'150px'} width={"310px"} />
            )})}
        </Grid>
      }

      {/* <Grid templateColumns={['repeat(1, 1fr)', 'repeat(1, 1fr)', 'repeat(3, 1fr)']} gap={6} mt={3} mb={6}>
        {openDossiers.map((dossier, index) => {
          return (
            <BigDossierCard key={index} dossier={dossier} />
          )})}
      </Grid> */}
      
      {openDossiers.map((dossier, index) => {
        return (
          <Box key={index} mb={(index < 2) ? 2 : 0}>
            <BigDossierCard dossier={dossier} />
          </Box>
      )})}

      <Flex pb={"30px"} mt={3} mb={4}>
        <Spacer />
        <ReactLink to={'/dossiers'} onClick={() => {window.scrollTo(0, 0);}}>
          <Text className='hvr-grow' cursor={"pointer"} color={"#00707f"} opacity={0.8} fontSize={"sm"} fontWeight={900}>ACCÉDER AUX FILTRES</Text>
        </ReactLink>
      </Flex>
    </Box>

    {/* <Text fontWeight={'900'} color={"#e6e6e1"} fontSize={['5xl', '5xl', '7xl']} letterSpacing={"-.1rem"} mb={5} mt={5}>News</Text>

    {articlesFetched && articles.length > 0 &&
      <Box height={"100px"} />
    } */}

    {/* ARTICLES */}

    {/* {articlesFetched && articles.length === 0 && <Center>
      <Text mb={5} color={"gray.500"}>Aucun article pour le moment.</Text>
    </Center>} */}

    {/* {articlesFetched && articles.length > 0 && (<Grid position={"relative"} bottom={"100px"} templateColumns={['repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(3, 1fr)']}>
      {articles.map((article, index) => {
        return (<Box mt={"120px"} me={index == 2 ? 0 : 10} key={index}>
          <ArticleCard article={article} />
          </Box>
      )
    })}

    </Grid>)} */}

    {/* SKELETONS BOX */}
    
    {/* {!articlesFetched && (<Flex>
      {[1, 2, 3].map((_, i) => <Box key={i}>{ArticleCardSkeleton(i == 3)}</Box>)}
    </Flex>)} */}

    {/* <Flex mt={3} mb={4}>
      <Spacer />
      <ReactLink to={'/news'}>
        <Text className='hvr-grow' cursor={"pointer"} color={"#00707f"} opacity={0.8} fontSize={"sm"} fontWeight={900}>VOIR TOUTES LES NEWS ADERE</Text>
      </ReactLink>
    </Flex> */}

    {/* <Feed /> */}

    <Box height={"400px"} />
      
    </Layout>
  </>);
}

export default Home;